/** Stable small labels for drafting-style markers on the canvas. */
export function sheetRefFromId(id: string): string {
	let h = 0;
	for (let i = 0; i < id.length; i++) {
		h = (Math.imul(31, h) + id.charCodeAt(i)) | 0;
	}
	const n = (Math.abs(h) % 900) + 100;
	return `A-${n}`;
}
